/* Záložky obsahu na produktovém detailu (Popis / Parametry / Ostatní /
   Recenze). Panely jsou server-rendered, neaktivní mají [hidden]; element
   jen přepíná aria-selected + hidden a drží hash v URL, takže odkaz
   "Přečíst recenze" (#recenze) funguje i jako deep-link. */

if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      connectedCallback() {
        this.links = [...this.querySelectorAll('.pdp-tabs__link')];
        this.panels = [...this.querySelectorAll('.pdp-tabs__panel')];

        this.links.forEach((link) =>
          link.addEventListener('click', (event) => {
            event.preventDefault();
            this.activate(link.dataset.tab);
            history.replaceState(null, '', `#${link.dataset.tab}`);
          })
        );

        const requested = location.hash.slice(1);
        if (requested && this.querySelector(`[data-tab="${requested}"]`)) {
          this.activate(requested);
          this.scrollIntoView({ block: 'start' });
        }

        // deep-link z jiného místa stránky (řádek hodnocení u titulku)
        this.onHashChange = () => {
          const tab = location.hash.slice(1);
          if (tab && this.querySelector(`[data-tab="${tab}"]`)) {
            this.activate(tab);
            this.scrollIntoView({ block: 'start' });
          }
        };
        window.addEventListener('hashchange', this.onHashChange);
      }

      disconnectedCallback() {
        window.removeEventListener('hashchange', this.onHashChange);
      }

      activate(name) {
        this.links.forEach((link) =>
          link.setAttribute('aria-selected', link.dataset.tab === name ? 'true' : 'false')
        );
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.tab !== name;
        });
      }
    }
  );
}
